import { omitBy } from 'lodash-es';
import type { CoreTypes } from '../../core';
import type { Syllabus } from '../types/syllabus';

export default (syllabuses: Syllabus[]): CoreTypes.MixedWithoutInternalId.Syllabus[] => {
  if (!Array.isArray(syllabuses))
    throw new Error('(SS12000::From::Syllabus) Syllabus input is not of array type', { cause: 'invalid_input' });

  return syllabuses
    .map((syllabus): CoreTypes.MixedWithoutInternalId.Syllabus => ({
      ids:         syllabus.id,
      schoolType:  syllabus.schoolType!,
      official:    syllabus.official!,
      subjectName: syllabus.subjectName!,
      ...omitBy({
        subjectDesignation: syllabus.subjectDesignation,
        subjectCode:        syllabus.subjectCode,
        curriculum:         syllabus.curriculum,
      }, x => x == null),
    }));
};